
import Vue from "vue";
import AppContainer from "@/components/login/LoginContainer.vue";
import { AuthService } from "../services/auth-service";
import AppErrorBox from "@/components/common/ErrorMessageBox.vue";
import AppSection from "@/components/login/LoginSection.vue";
import { HttpError } from "../utils/services/http-error";
import { UserInfo } from "@/models/dossier/user-info";

export default Vue.extend({
	data() {
		return {
			activationResult: "",
			activationComplete: false,
			user: new UserInfo()
		};
	},
	computed: {
		showError(): boolean {
			return this.activationResult != "";
		}
	},
	methods: {
		async activate() {
			try {
				this.user = await AuthService.activate(this.$route.params.token);
				await AuthService.getUserInfo();
				this.activationComplete = true;

			} catch (err) {
				let e = err as HttpError;
				e.dontShow = true;
				this.activationResult = e.getText();
			}
		}
	},
	mounted() {
		let splashEl = document.getElementById("splash");
		if (splashEl) {
			splashEl.remove();
		}

		this.activate();
	},
	components: {
		AppContainer,
		AppErrorBox,
		AppSection
	},
	i18nEx: {
		componentPrefix: "views.AccountActivation"
	},
});
